import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { RideButton, RideGlArrowBack, RideGrid } from '@rimac-seguros/ride-system-components';
import { useHistory } from '../../../hooks/useHistory';

import './styles.scss';

const Stepper = ({
  currentStep,
  routeMain,
  itemsStepsRoutes,
  hasBorderTop,
}) => {
  const [step, setStep] = useState(1);
  const { navigate } = useHistory();

  useEffect(() => {
    if (currentStep) {
      setStep(currentStep);
    }
  }, [currentStep]);

  const handleClickBack = () => {
    setStep(step - 1);
    navigate(itemsStepsRoutes[step - 2] ?? routeMain);
  };

  useEffect(() => {
    window.addEventListener('popstate', handleClickBack);

    return () => {
      window.removeEventListener('popstate', handleClickBack);
    };
  }, []);

  const percentComplete = `${(step / itemsStepsRoutes.length) * 100}`;

  window.handleClickBack = () => handleClickBack();

  return (
    <div className={`container-steps ${step > 1 ? 'custom-bg' : ''} ${hasBorderTop ? 'additional-border-t' : ''}`}>
      <RideGrid>
        <div className="container-steps_content">
          <div className="go-back-mobile">
            <div onClick={handleClickBack}>
              <RideGlArrowBack size="x-large" />
            </div>
            <span className="step-info">
              Paso {step} de {itemsStepsRoutes.length}
            </span>
          </div>
          <RideButton
            text={`Paso ${step} de ${itemsStepsRoutes.length}`}
            size="large"
            variant="text-secondary"
            glyph={<RideGlArrowBack />}
            glyphPosition="left"
            className="go-back-desktop"
            onClick={handleClickBack}
          />
          <div className="progress-bar-step">
            <div className="progress-bar-step_completed" style={{ width: `${percentComplete}%` }} />
          </div>
        </div>
      </RideGrid>
    </div>
  );
};

Stepper.defaultProps = {
  currentStep: 1,
};

Stepper.propTypes = {
  currentStep: PropTypes.number,
  routeMain: PropTypes.string.isRequired,
  itemsStepsRoutes: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasBorderTop: PropTypes.bool.isRequired,
};

export default Stepper;
